import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"font-size":"18px","margin":"25px 0 0","font-weight":"bold"} }
const _hoisted_7 = {
  key: 1,
  class: "rv rv-signed"
}
const _hoisted_8 = { class: "rv-sn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_role_seat = _resolveComponent("role-seat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      (_ctx.signOff.SignatureData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.signOff.SignatureData
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.signOff.Signature), 1),
      (_ctx.signOff.Seat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.seatLabel(_ctx.signOff.Seat) || 'Seat'), 1),
            _createVNode(_component_role_seat, {
              accountabilities: _ctx.signOff.Seat.accountabilities,
              sections: _ctx.signOff.Seat.sections,
              prefix: "signed"
            }, null, 8, ["accountabilities", "sections"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}